import React from 'react';

export default function ArrowActive() {
    return (
        <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <defs>
                <polygon id="path-etrr4u382h-1" points="0 0 17.6 0 17.6 18 0 18"></polygon>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="arrow-right" transform="translate(0.400000, 0.000000)">
                    <mask id="mask-etrr4u382h-2" fill="white">
                        <use xlinkHref="#path-etrr4u382h-1"></use>
                    </mask>
                    <g id="path-1"></g>
                    <path d="M8.16233115,0 L11.6656889,0 L17.6,8.98042075 L11.6616557,18 L8.16233115,18 L14.0991895,8.98380743 L8.16233115,0 Z M0,0 L3.5031455,0 L9.43788113,8.98042075 L3.49868777,18 L0,18 L5.93685836,8.98380743 L0,0 Z" id="Fill-1" fill="#0068B4" fillRule="nonzero" mask="url(#mask-etrr4u382h-2)"></path>
                </g>
            </g>
        </svg>
    );
}